import { SET_SCHEDULED_MESSAGES, ADD_SCHEDULED_MESSAGE, DELETE_SCHEDULED_MESSAGE, UPDATE_SCHEDULED_MESSAGE } from "./constants";

const initialState = {
  scheduledMessages: [],
};

const ScheduledMessages = (state = initialState, action) => {
  switch (action.type) {
    case SET_SCHEDULED_MESSAGES:
      return { ...state, scheduledMessages: action.payload };

    case ADD_SCHEDULED_MESSAGE:
      return {
        ...state,
        scheduledMessages: [action.payload, ...state.scheduledMessages],
      };

    case DELETE_SCHEDULED_MESSAGE:
      return {
        ...state,
        scheduledMessages: state.scheduledMessages.filter(
          (message) => message._id !== action.payload
        ),
      };

    case UPDATE_SCHEDULED_MESSAGE:
      return {
        ...state,
        scheduledMessages: state.scheduledMessages.map((message) =>
          message._id === action.payload.messageId
            ? { ...message, ...action.payload.updatedMessage }
            : message
        ),
      };

    default:
      return state;
  }
};

export default ScheduledMessages;
